var hbBasketTemplate;
var hbEmptyTemplate;
var shortTimeoutDuration = 1500;
var longTimeoutDuration = 10000; 


// Init
// ==========================

function initBasket() {
    console.log("Init basket");

    // Init handle bars
    hbBasketTemplate = Handlebars.compile(document.getElementById("basket-row").innerHTML);
    hbEmptyTemplate = Handlebars.compile(document.getElementById("basket-empty").innerHTML);


    getBasket().then(function (result) {
        renderBasket(result);
    });

    // Change line item quantity
    $('section.basket-listing').on("change", "input.line-item", function (e) {

        var lineId = $(this).attr('data-line');
        var quantity = parseInt($(this).val());

        //if (quantity === 0) {
        //    alert('Please enter a quantity greater than 0 or remove using the cross.');
        //    return;
        //}
        console.log('Changed amount on item : %o to %o', lineId, quantity);

        updateLineItemAmount(lineId, quantity).then(function (result) {
            console.log('Updated : %o', result);
            renderBasket(result);
            updateBasketItemCountNav(result.TotalItemsInBasket);
        });
    });
    $('section.basket-listing').on("click", ".quantity-decrease", function (e) {
        var input = $(this).next();
        var lineId = input.attr('data-line');
        var quantity = parseInt(input.val());
        var newQuantity = quantity - 1;
        //if (newQuantity === 0) {
        //    alert('Please enter a quantity greater than 0 or remove using the cross.');
        //    return;
        //}
        console.log('Changed amount on item : %o to %o', lineId, newQuantity);

        updateLineItemAmount(lineId, newQuantity).then(function (result) {
            console.log('Updated : %o', result);
            renderBasket(result);
            updateBasketItemCountNav(result.TotalItemsInBasket);
        });
    });
    $('section.basket-listing').on("click", ".quantity-increase", function (e) {
        var input = $(this).prev();
        var lineId = input.attr('data-line');
        var quantity = parseInt(input.val());
        var newQuantity = quantity + 1;
        if (newQuantity === 0) {
            alert('Please enter a quantity greater than 0 or remove using the cross.');
            return;
        }
        console.log('Changed amount on item : %o to %o', lineId, newQuantity);

        updateLineItemAmount(lineId, newQuantity).then(function (result) {
            console.log('Updated : %o', result);
            renderBasket(result);
            updateBasketItemCountNav(result.TotalItemsInBasket);
        });
    });
    $('section.basket-listing').on("click", "#basket-update", function (e) {

        e.preventDefault();

        updateAllLineItemsAmount().then(function (result) {
            console.log('Updated : %o', result);
            renderBasket(result);
        });
    });

    // Check voucher code
    $('section.basket-listing').on("click", "#discount-button", function (e) {

        e.preventDefault();
        console.log('Checking discount');

        checkDiscountCode();
    });

    // Remove item
    $('section.basket-listing').on("click", "i.remove", function (e) {

        e.preventDefault();

        var lineId = $(this).attr('data-line');
        var quantity = 0;

        console.log('Changed amount on item : %o to %o', lineId, quantity);

        updateLineItemAmount(lineId, quantity).then(function (result) {
            console.log('Updated : %o', result);
            renderBasket(result);
            updateBasketItemCountNav(result.TotalItemsInBasket);
        });
    });
}

function initProductDetails() {
    console.log("Init details");

    //  Add item to cart - Product details
    $('button.product-details__button').click(function (e) {
        console.log('Add product');
        var $that = $(this);


        // Varient sku
        itemVarientSKU = '';
        var variantLabelVal = $('label[for="variant"]').text();
        var variant = $('#variant').val();
        var variantSelectedText = $("#variant option:selected").text();
        var $validationElement = $('.validation');
        if (variant !== undefined) {
            if (variant === "0") {
                $validationElement.removeClass('hidden').find('p').html('Please select a ' + variantLabelVal);
                return;
            } else {
                $validationElement.addClass('hidden');
                itemVarientSKU = variant;
            }
        }

        itemSKU = $('#product-sku').val();
        if (itemSKU == '') {
            alert('Product page missing product SKU');
            return;
        }

        // Save for later
        var startingText = $(this).text();
        $(this).text('Adding')


        quantity = 1;

        addItemToBasket(itemSKU, itemVarientSKU, quantity).then(function (result) {
            console.log('Added : %o', result);

            // Update the button 
            $that.text('Added');
            // Get count and update basket summary
            //$('#basket-Items').text('(' + result + ')');
            updateBasketItemCountNav(result);

            var $successMessage = $('#successMessage');
            flashSuccessMessageDetails($successMessage, variantLabelVal, variantSelectedText);

            $('.itemAdded').removeClass('hidden').find('p').html($('.main-content__title').text() + " ");
            setTimeout(function () {
                $that.text(startingText);
            }, shortTimeoutDuration);

        });
    });
   
}

function initRelatedProducts() {
    $('button.related-product__button').click(function (e) {
        console.log('Add product');
        // Save for later
        var startingText = $(this).text();

        $(this).text('Adding');

        itemSKU = $(this).attr('data-sku');
        if (itemSKU == '') {
            alert('Missing product SKU');
            return;
        }
        // Varient sku - always empty
        itemVarientSKU = '';

        quantity = 1;

        addItemToBasket(itemSKU, itemVarientSKU, quantity).then(function (result) {

            var $this = $(this);

            // Update the button 
            $this.text('Added');
            // Get count and update basket summary
            var that = this;
            //$('#basket-Items').text('(' + result + ')');
            updateBasketItemCountNav(result);

            //var $successContainer = $this.closest('.related-row');
            //flashSuccessMessageListing($successContainer);

            setTimeout(function () {
                $(that).text(startingText);
            }, shortTimeoutDuration);

        }.bind(this));
    });
}

function initProductListing() {
    console.log("Init listing");

    $('button.button.product-panel__button').click(function (e) {
        console.log('Add product');
        // Save for later
        var startingText = $(this).text();

        $(this).text('Adding');

        itemSKU = $(this).attr('data-sku');
        if (itemSKU == '') {
            alert('Missing product SKU');
            return;
        }
        // Varient sku - always empty
        itemVarientSKU = '';

        quantity = 1;

        addItemToBasket(itemSKU, itemVarientSKU, quantity).then(function (result) {

            var $this = $(this);

            // Update the button 
            $this.text('Added');
            // Get count and update basket summary
            var that = this;
            //$('#basket-Items').text('(' + result + ')');
            updateBasketItemCountNav(result);

            var $successContainer = $this.closest('.panel-row__col-content');
            flashSuccessMessageListing($successContainer);

            setTimeout(function () {
                $(that).text(startingText);
            }, shortTimeoutDuration);

        }.bind(this));


    });

}

function initAddress() {
    console.log("Init address");

    $('form.validate').each(function () {
        $(this).validate({
            errorElement: "span",
            errorClass: "help-inline",
            highlight: function (label) {
                $(label).closest('.control-group').addClass('error');
            },
            success: function (label) {
                label.closest('.control-group').addClass('success');
            },

            rules: {
                "BillingAddress.FirstName": "required",
                "BillingAddress.FirstName": "required",
                "BillingAddress.Line1": "required",
                "BillingAddress.City": "required",
                "BillingAddress.PostalCode": "required",
                "BillingAddress.EmailAddress": {
                    required: true,
                    email: true
                }
            },
            messages: {
                "BillingAddress.FirstName": "Please specify your first name",
                "BillingAddress.LastName": "Please specify your last name",
                "BillingAddress.Line1": "Please specify your Street name and number",
                "BillingAddress.City": "Please specify your City / Town",
                "BillingAddress.PostalCode": "Please specify your postcode",
                "BillingAddress.EmailAddress": {
                    required: "Please specify your email address",
                    email: "Your email address must be in the format of name@domain.com"
                }
            }
        });

    });

    $('#IsShippingAddressDifferent').change(function (e) {
        if (this.checked) {
            $('#shippingAddress').removeClass('hidden');
        } else {
            $('#shippingAddress').addClass('hidden');
        }
    });

}

function initStripeCheckout(PublishableKey) {

    console.log('initStripeCheckout');

    // Make sure we have a key
    if (PublishableKey === null || PublishableKey === '') {
        alert('Stripe publishable key missing');

        checkoutButton.addEventListener('click', function () {
            alert('Stripe publishable key missing');
        });

        return;
    }
    doStripeCheckout(PublishableKey);

    $('#checkout-button').click(function (e) {
        console.log('initStripeCheckout #checkout-button')
        e.preventDefault();
        doStripeCheckout(PublishableKey);

        /*
        fetch('/umbraco/surface/UCommCheckout/CreateCheckoutSession', {
            method: 'POST',
        })
        .then(function (response) {
            return response.json();
        })
        .then(function (session) {
            return stripe.redirectToCheckout({ sessionId: session.id });
        })
        .then(function (result) {
            // If `redirectToCheckout` fails due to a browser or network
            // error, you should display the localized error message to your
            // customer using `error.message`.
            if (result.error) {
                alert(result.error.message);
            }
        })
        .catch(function (error) {
            console.log('catch error during InitStripeCheckout : %o' + error)
            alert('catch error during InitStripeCheckout : ' + error.message);
            console.error('Error:', error);
        });
        */
    });

}

 
// Helpers
// ==========================

function doStripeCheckout(PublishableKey) {
    // Create an instance of the Stripe object with your publishable API key
    var stripe = Stripe(PublishableKey);

    fetch('/umbraco/surface/UCommCheckout/CreateCheckoutSession', {
        method: 'POST',
    })
        .then(function (response) {
            return response.json();
        })
        .then(function (session) {
            return stripe.redirectToCheckout({ sessionId: session.id });
        })
        .then(function (result) {
            // If `redirectToCheckout` fails due to a browser or network
            // error, you should display the localized error message to your
            // customer using `error.message`.
            if (result.error) {
                alert(result.error.message);
            }
        })
        .catch(function (error) {
            console.log('catch error during initStripeCheckout : %o' + error)
            alert('catch error during initStripeCheckout : ' + error.message);
            console.error('Error:', error);
        });
}

function flashSuccessMessageListing($successContainer) {
    var $successMessage = $successContainer.find('.successMessage');
    var productTitle = $successContainer.find('h2.panel__title').text();
    var message = '<p><b>' + productTitle + '</b> has been added to your bag.</p><br /><a href="' + BasketUrl + '">View bag</a>';

    $successMessage.html(message).fadeIn(400, function () {
        setTimeout(function () {
            $successMessage.fadeOut(400);
        }, longTimeoutDuration);
    });
}

function flashSuccessMessageDetails($successMessage, variantLabelVal, variantSelectedText) {
    var productTitle = $('h1.main-content__title').text();
    var message = '';
    if (variantSelectedText !== '') {
        message = '<p><b>' + productTitle + '</b> - ' + variantLabelVal + ' : ' + variantSelectedText + ' has been added to your basket.</p><br /><a href="' + BasketUrl + '">View basket</a>';
    } else {
        message = '<p><b>' + productTitle + '</b> has been added to your basket.</p><br /><a href="' + BasketUrl + '">View basket</a>';

    }

    $successMessage.html(message).fadeIn(400, function () {
        setTimeout(function () {
            $successMessage.fadeOut(400);
        }, longTimeoutDuration);
    });
}

function renderBasket(result) {
    //console.log('renderBasket : %o', result);
    var finished = '';
    if (result.Products.length > 0) {
        finished = hbBasketTemplate(result);
    } else {
        finished = hbEmptyTemplate();
    }

    $('.basket-listing').html(finished);
}

function updateBasketItemCountNav(newCount) {
    $('#basket-Items').text('(' + newCount + ')');
}

function checkDiscountCode(code) {

    var $discountMessage = $('.discountResult');
    var $discountField = $('#discountCode');
    if (code === '' || code === undefined) {
        code = $discountField.val();
    }

    // If no code show an error and put the focus into the text box
    if (code === '') {
        $discountMessage.text("Please enter your code");
        $discountField.focus();
    }

    checkDiscountCodeAPI(code).then(function (result) {
        console.log('checkDiscountCodeAPI : %o', result);
        var $discountMessage = $('.discountResult');

        if (result.Key === 'Invalid code') {
            $discountMessage.text(result.Key);
        } else {
            console.log(result.DiscountPercent + '% off your order');
            //$discountMessage.text(result.DiscountPercent + '% off your order');
            renderBasket(result);
        }

    });

}


// API Calls
// ==========================

function updateLineItemAmount(itemId, quantity) {
    return new Promise(function (resolve, reject) {

        var qsData = {
            lineItemId: itemId,
            newQuantity: quantity
        }

        $.ajax({
            url: "/umbraco/surface/UComm/UpdateLineItemAmount",
            method: 'post',
            data: qsData
        }).done(function (result) {
            console.log('Success : %o', result);
            resolve(result);
        }).fail(function (result) {
            console.log('Failed');
            reject(result);
        });

    });
}

function updateAllLineItemsAmount() {
    return new Promise(function (resolve, reject) {

        var updates = {
            items: []
        }

        // Loop through the quantity fields
        $.each($('.basket-item input[type=text]'), function (i, v) {

            var $field = $(v);
            var quantity = parseInt($field.val());

            //if (quantity === 0) {
            //    alert('Please enter a quantity greater than 0 or remove using the cross.');
            //    return;
            //}

            if ($field.attr("data-line") != '') {
                updates.items.push({
                    lineItemId: parseInt($field.attr("data-line")),
                    newQuantity: quantity
                });
            }
        });

        console.log('Basket quantity update : %o', updates);

        $.ajax({
            url: "/umbraco/surface/UComm/UpdateLineItemsAmount",
            method: 'post',
            data: updates
        }).done(function (result) {
            console.log('Success : %o', result);
            resolve(result);
        }).fail(function (result) {
            console.log('Failed');
            reject(result);
        });

    });
}

function addItemToBasket(itemSKU, itemVarientSKU, quantity) {
    return new Promise(function (resolve, reject) {

        var qsData = {
            quantity: quantity,
            SKU: itemSKU
        }
        if (itemVarientSKU !== null && itemVarientSKU != '') {
            qsData.variantSku = itemVarientSKU;
        }

        $.ajax({
            url: "/umbraco/surface/UComm/AddProductToBasket",
            method: 'post',
            data: qsData
        }).done(function (result) {
            console.log('Success : %o', result);
            resolve(result);
        }).fail(function (result) {
            console.log('Failed');
            reject(result);
        });

    });
}

function getBasket() {
    return new Promise(function (resolve, reject) {

        $.ajax({
            url: "/umbraco/surface/UComm/GetBasketContents",
            method: 'post',
            data: {}
        }).done(function (result) {
            console.log('Success : %o', result);
            resolve(result);
        }).fail(function (result) {
            console.log('Failed');
            reject(result);
        });

    });
} 

function checkDiscountCodeAPI(code) {
    return new Promise(function (resolve, reject) {

        var qsData = {
            code: code
        }

        $.ajax({
            url: "/umbraco/surface/UComm/CheckDiscountCode",
            method: 'post',
            data: qsData
        }).done(function (result) {
            console.log('Success : %o', result);
            resolve(result);
        }).fail(function (result) {
            console.log('Failed');
            reject(result);
        });

    });
} 


// Handlebars helpers
// ==========================

Handlebars.registerHelper("numberInCartList", function (optCount, selectedOpt) {

    var ret = '';

    for (var i = 0, j = optCount; i < j; i++) {
        selected = '';
        if (selectedOpt == i) { selected = ' selected="selected"'; }
        ret = ret + "<option value='" + i + "'" + selected + ">" + i + "</option>";
    }

    return new Handlebars.SafeString(ret);

});

